import { Button } from '@barfacil/barfacil-ui'
import { useMemo } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import { Breadcrumb } from '@/app/panel/_components/breadcrumb'

export const ManagementLayout = ({ children }: React.PropsWithChildren) => {
  const navigate = useNavigate()
  const location = useLocation()

  const managementPrefix = '/cadastros'
  const steps = useMemo(
    () => [
      {
        prefix: managementPrefix,
        pathname: 'lista-de-precos',
      },
      {
        prefix: managementPrefix,
        pathname: 'layout',
      },
      {
        prefix: managementPrefix,
        pathname: 'eventos',
      },
      {
        prefix: '/terminais',
        pathname: 'opcoes',
      },
    ],
    [],
  )

  const currentStepIndex = useMemo(
    () => steps.findIndex((step) => location.pathname.endsWith(step.pathname)),
    [steps, location.pathname],
  )

  const isBackButtonDisabled = useMemo(
    () => currentStepIndex === 0,
    [currentStepIndex],
  )

  const handleNext = () => {
    if (currentStepIndex < steps.length - 1) {
      const nextStep = steps[currentStepIndex + 1]
      navigate(`${nextStep.prefix}/${nextStep.pathname}`)
    }
  }

  const handleBack = () => {
    if (currentStepIndex > 0) {
      const prevStep = steps[currentStepIndex - 1]
      navigate(`${prevStep.prefix}/${prevStep.pathname}`)
    }
  }

  return (
    <section className="mb-4 flex size-full flex-col gap-4 sm:px-8">
      <Breadcrumb />

      <div className="flex flex-1 flex-col gap-4">{children}</div>

      <footer className="flex flex-col-reverse gap-4 sm:ml-auto sm:flex-row">
        <Button
          className="min-w-36"
          variant="tertiary"
          disabled={isBackButtonDisabled}
          onClick={handleBack}
        >
          Voltar
        </Button>
        <Button className="min-w-36" onClick={handleNext}>
          Avançar
        </Button>
      </footer>
    </section>
  )
}
